import { api } from '../api/client';
import { API_CARD_ACTIONS_URL, API_ITEM_ACTION_RUN_URL, API_ITEM_CARD_ACTIONS_URL } from '../utils';

// Card actions (keepr-api docs/SCHEMA.md § Card actions; KPR-382, KPR-548):
// a button a manager defined on a card, pressed by anyone who can edit the
// record. The press writes AS THE PERSON, through the record's own rules.

/**
 * Every button the caller could press in one collection — ONE request for the
 * whole collection, so a table or a tile grid never asks per row. Each row is
 * `{ _id, name, card_id, appliesTo: [cardId], button: { label, icon?, confirm? },
 * inputs: [{ key, label, dataType, options }], conditional?, inherited? }`.
 * `conditional` (KPR-1342): it applies only to some records — which ones is
 * getItemCardActions'.
 */
export async function getCardActions(collectionId) {
	const { data } = await api.get(API_CARD_ACTIONS_URL(collectionId));
	return Array.isArray(data) ? data : [];
}

/**
 * One record's buttons (KPR-1342): the rows above for its card, each with
 * `applies` — whether its condition holds for this record as the caller reads
 * it — and, where it does not, the `reason` a person reads. The API is the
 * one judge (the press asks the same question); the client never matches a
 * condition itself.
 */
export async function getItemCardActions(itemId) {
	const { data } = await api.get(API_ITEM_CARD_ACTIONS_URL(itemId));
	return Array.isArray(data) ? data : [];
}

/**
 * Press one action on one record. `key` is the Idempotency-Key: the API runs a
 * key once and answers a resend with the first answer (`replayed: true`), so a
 * double click or a retry never writes twice. `attestation` rides as
 * X-Attestation when a card the press writes asks for a signature.
 * Errors propagate; `pressRefusal` (utils/cardActions) puts them in words.
 */
export async function pressCardAction(itemId, actionId, { inputs, key, attestation } = {}) {
	const headers = { 'Idempotency-Key': key };
	if (attestation) headers['X-Attestation'] = attestation;
	const { data } = await api.post(API_ITEM_ACTION_RUN_URL(itemId, actionId), { inputs: inputs || {} }, { headers });
	return data;
}
